import ProjectOverview from '../../../feedback/project-over.vue';
import ProfileOverview from '../../../profile/profile-overview.vue';
import ProfileLanding from '../../../profile/profile-landing.vue';
import ProfileInformation from '../../../profile/profile-information.vue';
import ProfileEmailAddress from '../../../profile/profile-email-address.vue';
import ProfilePassword from '../../../profile/profile-password.vue';
import ProfileQuestions from '../../../profile/profile-questions.vue';
import ProfileAchievements from '../../../profile/profile-achievements.vue';
import ManageKodsPage from '../../../profile/kods.vue';
import ChangePasswordPage from '../../../profile/change-password-page.vue';
import MainHelpPage from '../../../help/main-help-page.vue';
import KateIDE from '../../../ide/k-ide.vue';
import LoginPage from '../../../profile/login.vue';
import VerifyEmailPage from '../../../profile/verify-email.vue';
import NotFound from '../../../layout/not-found.vue';
import Forbidden from '../../../layout/forbidden.vue';
import AdvancedSetup from '../../../help/advanced-setup.vue';
import OtjGuidance from '../../../help/otj-guidance.vue';
import MeetingsGuidance from '../../../help/meetings-guidance.vue';
import ProjectTrackerGuidance from '../../../help/project-tracker-guidance.vue';
import PolicyPage from '../../../policy/policy.vue';
import PolicyAcceptPage from '../../../policy/policy-acceptance.vue';
import FingerprintPage from '../../../help/public-keys.vue';
import FeedbackInstructions from '../../../feedback/feedback-instructions.vue';
import FeedbackAppWrapper from '../../wrappers/kate_app/feedback-app-wrapper.vue';
import FeedbackNotebook from '../../../notebook/notebook.vue';
import ProgrammePage from '../../../programmes/programme-page.vue';
import MaintenancePage from '../../../layout/maintenance.vue';
import ModuleLu from '../../../module_pages/module-lu.vue';
import ModuleLanding from '../../../module_pages/module-landing.vue';
import ModuleOverview from '../../../module_pages/module-overview.vue';
import ModuleVideo from '../../../module_pages/module-video.vue';
import ModuleSlides from '../../../module_pages/module-slides.vue';
import CalendarEventPage from '../../../module_pages/module-calendar-event.vue';
import MeetingPage from '../../../module_pages/module-meeting.vue';
import ModuleMarkdownPage from '../../../module_pages/module-markdown-page.vue';
import ModuleQuestionnaire from '../../../questionnaires/questionnaire-page.vue';
import MeetingFormPage from '../../../questionnaires/meetings/app-meeting-form-page.vue';
import QuizPage from '../../../quizzes/quiz-page.vue';
import FeedbackLeaderboard from '../../../feedback/leaderboard.vue';
import ModuleKnowledgeBase from '../../../module_pages/module-knowledge-base.vue';
import ThreadPage from '../../../knowledge_base/thread-page.vue';
import SpinKodPage from '../../../profile/kod-loading.vue';
// Programme pages
import Competencies from '../../../programmes/competencies.vue';
import Curriculum from '../../../programmes/curriculum.vue';
import Milestones from '../../../programmes/milestones.vue';
import ProgrammeSchedule from '../../../programmes/programme-schedule.vue';
import UserNotInProgramme from '../../../programmes/user-not-in-programme.vue';
import ProgrammeOtjPage from '../../../programmes/programme-otj-page.vue';
import AppOtjLogs from '../../../programmes/app-otj-logs.vue';
import ProgrammeOtjGuidance from '../../../programmes/programme-otj-guidance.vue';
import ProjectTrackerPage from '../../../programmes/project-tracker-page.vue';
import ProjectEvidenceOverview from '../../../programmes/project_tracker_components/project-evidence-overview.vue';

// Learner Homepage
import LearnerHomepage from '../../../app/learner-homepage.vue';

// Chatbot pages
import ChatbotPage from '../../../programmes/chatbot/chatbot-page.vue';

// Key Portal pages
import LearnerApiKeyPortal from '../../../app/learner_keymaker_portal/learner-key-portal-page.vue';

function getModulePagePakKey(routeDetails) {
  return `pak_ov_${routeDetails.params.modulePakId}`;
}

const routes = [
  {
    path: '/login',
    component: LoginPage,
    name: 'login_page',
    kate_sidebar_disabled: true,
    kate_is_public: true,
    meta: {
      title: 'KATE - Login',
    },
  },
  {
    path: '/login_token',
    component: LoginPage,
    name: 'login_gl_page',
    props: {
      withGitlabToken: true,
    },
    kate_sidebar_disabled: true,
    kate_is_public: true,
    meta: {
      title: 'KATE - Login Token',
    },
  },
  {
    path: '/email_verification/:verificationType?',
    component: VerifyEmailPage,
    name: 'email_verification_page',
    kate_sidebar_disabled: true,
    kate_is_public: true,
    meta: {
      title: 'KATE - Email Verification',
    },
  },
  {
    path: '/home/:programmeId?',
    component: LearnerHomepage,
    kate_sidebar_disabled: true,
    kate_feature_flag: 'learner-homepage',
    name: 'home',
    meta: {
      title: 'KATE - Home',
    },
  },
  {
    path: '/programmes/:programmeId?/:track?',
    alias: '/',
    component: ProgrammePage,
    name: 'programme_page',
    meta: {
      title: 'KATE - Programme Page',
      prettyName: 'Programme Page',
      show: true,
      primaryNav: 'curriculum',
    },
    redirect: to => ({
      name: 'programme_curriculum',
      params: { programmeId: to.params.programmeId },
    }),
    children: [
      {
        path: 'curriculum',
        component: Curriculum,
        name: 'programme_curriculum',
        kate_sidebar_disabled: true,
        meta: {
          title: 'KATE - Programme Curriculum',
        },
      },
      {
        path: 'milestone',
        component: Milestones,
        name: 'programme_milestones',
        kate_sidebar_disabled: true,
        meta: {
          title: 'KATE - Programme Milestones',
        },
      },
      {
        path: 'competencies',
        component: Competencies,
        name: 'programme_competencies',
        kate_sidebar_disabled: true,
        meta: {
          title: 'KATE - Programme Competencies',
        },
      },
      {
        path: 'projects',
        component: ProjectTrackerPage,
        name: 'programme_projects',
        kate_sidebar_disabled: true,
        kate_feature_flag: 'kate-projects-app',
        meta: {
          title: 'KATE - Programme Projects',
        },
      },
    ],
    kate_sidebar_disabled: true,
  },
  {
    path: '/programmes/:programmeId/chat/:sessionId?',
    component: ChatbotPage,
    name: 'chatbot_page',
    kate_sidebar_disabled: true,
    kate_feature_flag: 'kate-bot',
    meta: {
      title: 'KATE - Learning Assistant',
      primaryNav: 'chat',
    },
  },
  {
    path: '/programmes/:programmeId/otj',
    component: ProgrammeOtjPage,
    name: 'programme_otj_page',
    kate_sidebar_disabled: true,
    redirect: { name: 'programme_otj_logs' },
    children: [
      {
        path: 'guidance',
        component: ProgrammeOtjGuidance,
        name: 'programme_otj_guidance',
        kate_sidebar_disabled: true,
        meta: {
          title: 'KATE - OTJ Guidance',
        },
      },
      {
        path: 'logs',
        component: AppOtjLogs,
        name: 'programme_otj_logs',
        kate_sidebar_disabled: true,
        meta: {
          title: 'KATE - OTJ Logs',
        },
      },
    ],
  },
  {
    path: '/programmes/:programmeId/projects/:projectId/evidence',
    component: ProjectEvidenceOverview,
    name: 'manage_programme_evidence',
    kate_sidebar_disabled: true,
    kate_feature_flag: 'kate-projects-app',
    props: route => ({
      programmeId: Number(route.params.programmeId),
      projectId: Number(route.params.projectId),
    }),
    meta: {
      title: 'KATE - Project Evidence Overview',
    },
  },
  {
    path: '/programmes/:programmeId?/schedule',
    component: ProgrammeSchedule,
    name: 'programme_schedule',
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - Programme Schedule',
    },
  },
  {
    path: '/modules/:moduleId',
    component: ModuleOverview,
    meta: {
      primaryNav: 'curriculum',
    },
    children: [
      {
        path: '',
        component: ModuleLanding,
        name: 'module_landing',
        meta: {
          title: 'KATE - Module Page',
        },
      },
      {
        path: 'video/:moduleVideoId',
        component: ModuleVideo,
        name: 'module_video',
        meta: {
          title: 'KATE - Module Video',
          moduleKey: () => 'module_video', // Don't remount ModuleVideo component if moduleVideoId changes
        },
      },
      {
        path: 'slides/:moduleSlidesId',
        component: ModuleSlides,
        name: 'module_slides',
        meta: {
          title: 'KATE - Module Slides',
        },
      },
      {
        path: 'lu/:moduleLuId/',
        component: ModuleLu,
        name: 'module_lu',
        meta: {
          title: 'KATE - Module LU',
        },
      },
      {
        path: 'pak/:modulePakId',
        component: ProjectOverview,
        children: [
          {
            path: '',
            alias: 'instructions',
            component: FeedbackInstructions,
            name: 'pak_ov_instructions',
            meta: {
              title: 'KATE - Feedback Instructions',
              moduleKey: getModulePagePakKey,
            },
          },
          {
            path: 'ide',
            component: KateIDE,
            name: 'pak_ov_web_ide',
            meta: {
              title: 'KATE - Web IDE',
              moduleKey: getModulePagePakKey,
            },
          },
          {
            path: 'feedback',
            component: FeedbackAppWrapper,
            name: 'pak_ov_feedback',
            meta: {
              title: 'KATE - Feedback',
              moduleKey: getModulePagePakKey,
            },
          },
          {
            path: 'solution',
            component: KateIDE,
            name: 'pak_ov_ide_solution',
            meta: {
              title: 'KATE - Web IDE Solution',
              moduleKey: getModulePagePakKey,
            },
          },
          {
            path: 'notebook',
            component: FeedbackNotebook,
            name: 'pak_ov_notebook',
            meta: {
              title: 'KATE - Notebook',
              moduleKey: getModulePagePakKey,
            },
          },
          {
            path: 'notebook_solution',
            component: FeedbackNotebook,
            name: 'pak_ov_notebook_solution',
            meta: {
              title: 'KATE - Notebook Solution',
              moduleKey: getModulePagePakKey,
            },
          },
          {
            path: 'leaderboard',
            component: FeedbackLeaderboard,
            name: 'pak_ov_leaderboard',
            meta: {
              title: 'KATE - Leaderboard',
              moduleKey: getModulePagePakKey,
            },
          },
        ],
      },
      {
        path: 'quiz/:moduleQuizId',
        component: QuizPage,
        name: 'module_quiz',
        meta: {
          title: 'KATE - Quiz',
        },
      },
      {
        path: 'calendar_event/:moduleCalendarEventId',
        component: CalendarEventPage,
        name: 'module_calendar_event',
        meta: {
          title: 'KATE - Calendar Event',
        },
      },
      {
        path: 'meeting/:moduleMeetingId',
        component: MeetingPage,
        name: 'module_meeting',
        meta: {
          title: 'KATE - Meeting',
        },
      },
      {
        path: 'meeting/:moduleMeetingId/form',
        component: MeetingFormPage,
        name: 'module_meeting_form',
        meta: {
          title: 'KATE - Meeting Form',
        },
      },
      {
        path: 'markdown_page/:moduleMarkdownPageId',
        component: ModuleMarkdownPage,
        name: 'module_markdown_page',
        meta: {
          title: 'KATE - Markdown Page',
        },
      },
      {
        path: 'questionnaire/:moduleQuestionnaireId',
        component: ModuleQuestionnaire,
        name: 'module_questionnaire',
        meta: {
          title: 'KATE - Questionnaire',
        },
      },
      {
        path: 'knowledge',
        component: ModuleKnowledgeBase,
        name: 'module_knowledge_base',
        meta: {
          title: 'KATE - Knowledge Base',
        },
      },
      {
        path: 'knowledge/thread/:threadId',
        component: ThreadPage,
        name: 'knowledge_thread',
        meta: {
          title: 'KATE - Knowledge Base Thread',
        },
      },
      {
        path: 'learner_keymaker_portal',
        component: LearnerApiKeyPortal,
        name: 'learner_keymaker_portal',
        kate_feature_flag: 'keymaker-app-page',
        props: route => ({
          programmeId: Number(route.params.programmeId),
        }),
        meta: {
          title: 'KATE - Learner API Key Portal',
        },
      },
    ],
  },
  {
    path: '/learning_environments/kods/:assetType/:assetId',
    component: SpinKodPage,
    name: 'spin_kod_page',
    kate_sidebar_disabled: true,
  },
  {
    path: '/maintenance',
    component: MaintenancePage,
    name: 'maintenance',
    kate_sidebar_disabled: true,
    kate_is_public: true,
  },
  {
    path: '/profile',
    component: ProfileOverview,
    children: [
      {
        path: '',
        component: ProfileLanding,
        name: 'profile_landing',
        meta: {
          title: 'KATE - Profile Page',
        },
      },
      {
        path: 'information',
        component: ProfileInformation,
        name: 'profile_information',
        meta: {
          title: 'KATE - Profile Information',
        },
      },
      {
        path: 'email',
        component: ProfileEmailAddress,
        name: 'profile_email_address',
        meta: {
          title: 'KATE - Profile Email Address',
        },
      },
      {
        path: 'password',
        component: ProfilePassword,
        name: 'profile_password',
        meta: {
          title: 'KATE - Profile Password',
        },
      },
      {
        path: 'knowledge',
        component: ProfileQuestions,
        name: 'profile_questions',
        meta: {
          title: 'KATE - Profile Knowledge Base',
        },
      },
      {
        path: 'knowledge/thread/:threadId',
        component: ThreadPage,
        name: 'profile_knowledge_thread',
        meta: {
          title: 'KATE - Profile Knowledge Base Thread',
        },
      },
      {
        path: 'achievements',
        component: ProfileAchievements,
        name: 'profile_achievements',
        meta: {
          title: 'KATE - Profile Achievements',
        },
      },
      // Redirect for the achievements view on the old badge route
      {
        path: 'badges',
        name: 'legacy_profile_badges',
        redirect: { name: 'profile_achievements' },
        meta: {
          title: 'KATE - Profile Achievements',
        },
      },
      {
        path: 'kods',
        component: ManageKodsPage,
        name: 'profile_manage_kods_page',
        meta: {
          title: 'KATE - Profile Manage Kods',
        },
      },
    ],
  },
  {
    path: '/change_password',
    component: ChangePasswordPage,
    name: 'change_password_page',
    kate_sidebar_disabled: true,
    kate_is_public: true,
    meta: {
      title: 'KATE - Change Password',
    },
  },
  {
    path: '/help',
    component: MainHelpPage,
    name: 'help',
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - Help',
    },
  },

  /* ==== HTML Help Pages ==== */

  {
    path: '/help/advanced_setup',
    component: AdvancedSetup,
    name: 'help_advanced_setup',
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - Help Advanced Setup',
    },
  },
  {
    path: '/help/otj_guidance',
    component: OtjGuidance,
    name: 'help_otj_guidance',
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - Help OTJ Guidance',
    },
  },
  {
    path: '/help/meetings_guidance',
    component: MeetingsGuidance,
    name: 'help_meetings_guidance',
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - Help Meetings Guidance',
    },
  },
  {
    path: '/help/project_tracker_guidance',
    component: ProjectTrackerGuidance,
    name: 'help_project_tracker_guidance',
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - Help Project Tracker Guidance',
    },
  },
  {
    path: '/help/fingerprints',
    component: FingerprintPage,
    name: 'help_kate_fingerprints',
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - Help Kate Fingerprints',
    },
  },
  {
    path: '/policy',
    component: PolicyAcceptPage,
    name: 'policy_accept_page',
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - Policy Accept Page',
    },
  },
  {
    path: '/policy/:policyType',
    component: PolicyPage,
    name: 'policy_page',
    props: true,
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - Policy Page',
    },
  },
  {
    path: '/user_not_in_programme',
    component: UserNotInProgramme,
    name: 'user_not_in_programme',
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - User Not In Programme',
    },
  },
  /* ==== 403 ==== */
  {
    path: '/403',
    component: Forbidden,
    name: '403',
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - 403',
    },
  },
  /* ==== 404 ==== */
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
    name: '404',
    kate_sidebar_disabled: true,
    meta: {
      title: 'KATE - 404',
    },
  },
];

export default routes;

export { getModulePagePakKey };
